module.exports = __webpack_public_path__ + "img/standard-membership.8743e36c.png";